import React, { useState } from 'react'

import { Box, Modal } from '@mui/material'

interface VideoPlayerProps {
  handleClose: () => void
}

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  height: '240px',
}

export const VideoPlayer = ({ handleClose }: VideoPlayerProps) => {
  const [open, setOpen] = useState<boolean>(true)

  const closeModal = () => {
    setOpen(false)
    handleClose()
  }

  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="modal-desc"
      open={open}
      onClose={closeModal}
      sx={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
    >
      <Box sx={{ ...style }}>
        <video autoPlay webkit-playsinline controls style={{ height: 'auto', width: '100%' }}>
          <source
            src="https://storage.googleapis.com/vera-statis-staging/tutorial/RPReplay_Final1695911975.mov"
            type="video/mp4"
          />
        </video>
      </Box>
    </Modal>
  )
}
